/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { ICategoryEntity, IUpdateCategoryPayload, ICreateCategoryPayload, IListCategoryPayload, IListCategoryResponse } from "./categories.interface";
import { Environment } from "../../../Config/constants";

export class CategoriesApiRemoteService {
  constructor(private service: AxiosInstance) {}

  public destroy = async (categoryId:string): Promise<Result<void>> => {
    try {
    
      const response = await this.service.delete(`/categories/${categoryId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async ({  categoryId, name, friendlyUrl, store}: IUpdateCategoryPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/categories/${categoryId}`, { name, friendlyUrl, store });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateCategoryPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.post(`/categories`, data);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async (data: IListCategoryPayload): Promise<Result<IListCategoryResponse>> => {
    try {
        const response = await this.service.get(`/categories`, { params: {
          page: data.page,
          searchBy: data.searchBy,
          store: data.store,
          offset: Number(Environment.OFFSET_REGISTERS),
          getAll: data.getAll
        } });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (categoryId: string): Promise<Result<ICategoryEntity>> => {
    try {
        const response = await this.service.get(`/categories/${categoryId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
